export default "/icon-checkbox-checked.svg";